/**
 * Logger Utility - Development-only logging
 *
 * Replaces direct console.log calls throughout the app.
 * In production, only errors are logged. In development, all levels are active.
 *
 * Usage:
 *   import { logger } from '../utils/logger';
 *   logger.log('Debug info');       // Only in development
 *   logger.warn('Warning');         // Only in development
 *   logger.error('Error', err);     // Always logged
 *   logger.info('Info');            // Only in development
 *   logger.api('GET /students');    // API-specific logging (dev only)
 */

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },

  info: (...args) => {
    if (isDev) console.info(...args);
  },

  warn: (...args) => {
    if (isDev) console.warn(...args);
  },

  // Errors are always logged (useful for production debugging)
  error: (...args) => {
    console.error(...args);
  },

  // API-specific logging with prefix
  api: (...args) => {
    if (isDev) console.log('[API]', ...args);
  },

  // Auth-specific logging with prefix
  auth: (...args) => {
    if (isDev) console.log('[AUTH]', ...args);
  },

  // Group logging for organized output
  group: (label, fn) => {
    if (isDev) {
      console.group(label);
      fn();
      console.groupEnd();
    }
  },
};

export default logger;
